import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContactType } from '../models/contact-type.model';
import { DataType } from '@core/lib/utils/httpRequestDataStorage';
import { GlobalDataStore } from '@core/lib/utils/httpRequestDataStorage/global-data.store';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContactTypesService extends GlobalDataStore<ContactType> {
  constructor(protected _http: HttpClient) {
    super(
      {
        server: environment.api,
        endpoint: ['contacts', 'types'],
        retryTimes: 3,
      },
      DataType.ARRAY,
      {
        adapters: {
          incoming: ContactType.adapt,
          //outgoing: ContactType.adaptAPI,
        },
        //database: { table: 'ContactTypes', expiresIn: '1D' },
      }
    );
  }

  getAllContactTypes() {
    this.fetchRecords([]);
  }
}
